{
  "account": {
    "title": "私のアカウント",
    "list": {
      "title": "アカウント",
      "description": "リンクされたアカウントの請求書リスト"
    },
    "form": {
      "name": {
        "title": "名前",
        "description": "あなたのアカウント名"
      },
      "password": {
        "title": "パスワード",
        "description": "アカウントの新しいパスワードを設定する。現在のパスワードを維持する場合は空欄にする。"
      },
      "emailPreferences": {
        "title": "Eメール設定",
        "description": "電子メールの通知タイプを選択してください"
      }
    },
    "billing": "支払明細",
    "subscriptions": "サブスクリプション",
    "manageSubscription": "サブスクリプションを管理する",
    "popup": {
      "downgrade": "ダウングレードしてもよろしいですか？ ダウングレードはすぐに有効になります。<br/>現在の請求サイクルの残りの時間については、リベートの対象にはなりませんのでご注意ください。<br/>新しいプランの価格は次の請求サイクルに適用されます。",
      "default": "計画を変更してもよろしいですか？",
      "cancel": "サブスクリプションをキャンセルしてもよろしいですか?<br/>あなたの Web サイトは、現在のサブスクリプション期間が終了するまで翻訳され続けます。それ以降、翻訳は無効になります。<br/>未使用期間については割引対象外となりますので予めご了承ください。",
      "resume": "サブスクリプションを再開してもよろしいですか?"
    }
  },
  "ai_translation": {
    "header": "AI翻訳",
    "plan": {
      "header": "AI翻訳の価格",
      "used": "AI クレジットで {words_used} / {words_allowed} 個の翻訳語を使用しました。",
      "remaining": "利用可能な AI クレジット:",
      "words": "言葉",
      "add_more_credits": "AIクレジットを追加する",
      "details": {
        "idiomatic_expressions": "慣用表現と専門表現",
        "background_translation": "バックグラウンドでの翻訳",
        "page_context": "翻訳のためのページとウェブサイトのコンテキスト",
        "perfect_quality": "完璧な品質、手頃な価格",
        "no_recurring": "定期支払いなし、前払い割り当て",
        "save_40": "20ドルプランと比べて40%お得",
        "save_50": "20ドルプランと比べて50%お得",
        "best_website": "完璧な翻訳品質を要求するウェブサイト"
      },
      "quota": "{estimated_words} 語 ~ {estimated_pages} ページ"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI翻訳",
        "intro": "Linguiseは、AI LLMモデル（翻訳タスク向けに最適化されたLlamaの最新モデル）を活用した新しいプレミアム機能、Linguise AI Translationを発表いたします。完璧な精度が求められるウェブサイト向けに設計されており、ページとウェブサイト全体のコンテキストの両方を考慮し、比類のない結果を実現します。クライアントに最高レベルの翻訳品質を提供し、あらゆる言語でメッセージが完璧に伝わるようにします。",
        "button": "今すぐアップグレード"
      },
      "alert": {
        "description": "この機能は現在のプランには含まれていないため、別途ご購入いただく必要があります。このアドオンを有効にすると、以下のすべてのオプションがご利用いただけるようになります。"
      },
      "languages": {
        "title": "AI翻訳を言語に適用する",
        "description": "AI翻訳を適用する特定の言語を選択してください"
      },
      "button": {
        "save": "設定を保存"
      },
      "form": {
        "rule_application": {
          "description": "AI翻訳を静的コンテンツ、動的コンテンツ、またはその両方に適用します",
          "title": "コンテンツに適用する",
          "all": "すべてのコンテンツ",
          "static": "静的コンテンツ",
          "dynamic": "動的コンテンツ"
        },
        "website_topic": {
          "title": "ウェブサイトのトピック",
          "placeholder": "寿司レストラン...",
          "description": "翻訳の品質を向上させるために、ウェブサイトのトピックを定義してください（例：法律、寿司レストラン、自転車部品のオンラインショップなど）\nウェブサイトのトピックは英語で入力してください。"
        },
        "apply_to_urls": {
          "title": "URLに適用",
          "description": "AI翻訳を適用するURLを選択してください",
          "all_urls": "すべてのURL",
          "selected_urls": "選択したURL",
          "label": "申請先のURL",
          "placeholder": "申請先のURL",
          "wildcard": "ワイルドカード",
          "regex": "正規表現",
          "add": "新規追加",
          "expression": "表現の種類"
        },
        "apply_languages": {
          "title": "言語に適用",
          "description": "AI翻訳を適用する特定の言語を選択してください",
          "all_languages": "すべての言語",
          "selected_languages": "選択した言語",
          "placeholder": "言語を選択...",
          "feedback": "言語を選択してください"
        },
        "enable_mode": {
          "title": "AI翻訳を有効にする",
          "description": "AI 翻訳を有効にする方法を選択します。\nルールは以下のルールのみ適用されます。\nライブ エディターでは、ライブ エディター ビューからページごとに翻訳を有効にすることのみが可能です。\nルールとライブ エディターは両方の機能を使用します。",
          "disabled": "無効",
          "rules": "ルールのみ",
          "live_editor": "ライブエディターのみ",
          "all": "ルールとライブエディター"
        },
        "formality": {
          "title": "形式",
          "description": "翻訳におけるフォーマル度合いを指定します。これは、読者や文脈によって重要となる場合があります。「ニュートラル」は、元のコンテンツのフォーマル度合いを維持するように努めます。「フォーマル」は、専門的、ビジネス的、または法的なコンテンツ（スペイン語で「usted」のようなフォーマルな代名詞の使用など）に適しています。「インフォーマル」は、カジュアルで会話的なコンテンツ（スペイン語で「tú」の使用など）に適しています。",
          "neutral": "中性",
          "formal": "フォーマル",
          "informal": "非公式"
        },
        "sentence_structure": {
          "classic": "クラシック",
          "short": "短くてパンチの効いた文章",
          "detailed": "詳細で説明的な文章",
          "title": "文の構造",
          "description": "書き方の好みを定義します。"
        },
        "content_purpose": {
          "marketing": "マーケティング/プロモーション（説得力のある、魅力的な口調）",
          "technical": "技術的/指導的（明確、正確、行動指向的）",
          "support": "顧客サポート（共感的、役立つ、安心できる）",
          "legal": "法的/コンプライアンス（正確、正式、明確）",
          "educational": "教育的（明確、構造化、アクセス可能）",
          "title": "コンテンツの目的",
          "description": "翻訳するコンテンツの機能的な目的を定義します。",
          "other_placeholder": "目的を説明してください...",
          "other": "その他（英語）"
        },
        "target_audience": {
          "title": "対象読者",
          "description": "翻訳されたコンテンツの対象読者の指定（英語）。",
          "placeholder": "例：スペイン語を話す親、EUのプライバシー担当者"
        },
        "advanced": {
          "title": "高度なAI指示",
          "description": "高度なAI指示"
        },
        "override_default_translations": {
          "title": "デフォルトの翻訳を上書きする",
          "description": "このオプションを YES に設定すると、コンテンツがすでに Cloud AI 翻訳 (デフォルトの翻訳モデル) によって翻訳されている場合でも、AI (Linguise AI) を使用して強制的に翻訳されます。"
        },
        "force_replace_before": {
          "title": "AI による再翻訳を強制",
          "description": "選択した日付より前に AI 翻訳されたコンテンツを、AI でもう一度翻訳します。たとえば、以前のモデルで翻訳されたコンテンツが対象です。ルールに適用されるページへの次回訪問時に再翻訳され、AI クレジットを使用します。",
          "before_date": "日付より前"
        },
        "model": {
          "current": "現在の",
          "title": "モデル",
          "description": "使用するLLM翻訳モデルを選択してください",
          "load_error": "利用可能なモデルを読み込めません。後でもう一度お試しください。",
          "thinking_warning": "このモデルは高いレベルの推論（\"思考\"）を使用し、翻訳ごとに大幅に多くのトークンを消費します。"
        },
        "override_manual_and_selected": {
          "no_default": "いいえ（デフォルト）",
          "title": "手動翻訳と選択した翻訳を上書き",
          "description": "デフォルトでは、手動で編集した翻訳は、AI強化翻訳が生成された後もウェブサイトに表示され続けます。代わりにAI強化翻訳を表示するには「はい」に設定してください。手動翻訳は保持され、いつでも元に戻せます。これは、新しい翻訳を取得するためにページを再翻訳する場合にも適用され、その際は最新の翻訳が自動的に使用されます。"
        }
      },
      "message": {
        "save_success": "現在翻訳済みのコンテンツのうち、AI 翻訳によって強化されるページの数はおよそ {{ai_affected_urls}} です。",
        "save_success_only": "設定が正常に保存されました。"
      }
    },
    "pricing": {
      "plan": {
        "title": "AI翻訳の割り当てを注文する",
        "buy_button": "AI翻訳パッケージを購入"
      },
      "modal": {
        "title": "プラン変更の確認",
        "description": "AI翻訳プランを変更してもよろしいですか?",
        "button_cancel": "キャンセル",
        "button_confirm": "確認する",
        "loading": "お待ちください...",
        "amount": "額",
        "credit": "クレジット",
        "total_due": "合計金額"
      },
      "comparison": {
        "title": "Google Cloud AI翻訳 vs Linguise AI翻訳",
        "list": {
          "0": {
            "google": "高速で信頼性の高い翻訳",
            "linguise": "慣用表現や専門表現を扱う"
          },
          "1": {
            "google": "ウェブサイトのすべてのページを即時翻訳",
            "linguise": "バックグラウンドでの翻訳の生成"
          },
          "2": {
            "google": "最高の品質、低価格",
            "linguise": "完璧な品質、手頃な価格"
          },
          "3": {
            "google": "大規模なウェブサイトや低予算に最適",
            "linguise": "完璧な翻訳品質が求められるウェブサイトに最適"
          },
          "4": {
            "google": "翻訳のためのページコンテキスト",
            "linguise": "翻訳のためのページとウェブサイトのコンテキスト"
          }
        }
      },
      "botom_banner": {
        "title": "比類のない翻訳精度を体験してください",
        "sub_title": "新しい言語AI翻訳",
        "description": "Linguiseは、最先端のAI翻訳LLM（翻訳に最適化された最新のLlamaモデル）を活用した強力な新オプション「Linguise AI Translation」の導入により、自動翻訳サービスを強化します。この追加機能により、ウェブサイト開発者やウェブエージェンシーは、より高品質な翻訳を利用できるようになります。これは、完璧さが最優先されるプロジェクトに最適です。Linguise AI Translationは、既存の高品質なGoogle Cloud AI翻訳を補完し、より高い柔軟性と精度を実現します。"
      }
    },
    "success": {
      "tab_title": "AI翻訳プランをご購入いただきありがとうございます！",
      "title": "AI翻訳プランをご購入いただきありがとうございます！",
      "subtitle": "AI翻訳プランの購入が完了しました。",
      "message": "AI 翻訳プランは、AI 翻訳設定ページで管理できます。",
      "home": "AI翻訳を管理する"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "名前",
        "description": "請求先のアカウント名"
      },
      "phone": {
        "title": "でんわ",
        "description": "請求先の電話"
      },
      "email": {
        "title": "Eメール",
        "description": "請求先のアカウントのメール"
      },
      "address": {
        "title": "住所",
        "description": "請求先の住所",
        "city": "市",
        "country": "国",
        "address1": "住所1",
        "address2": "住所2",
        "postal": "郵便番号",
        "state": "州"
      },
      "tax": {
        "title": "税番号"
      }
    }
  },
  "checkouts": {
    "header": "チェックアウト",
    "payment_method": "支払い方法を選択してください",
    "stripe_card": "クレジットカード（ストライプ）",
    "paypal": "ペイパル",
    "address": {
      "new": "新しい請求先住所を入力してください",
      "existing": "既存のアドレスを使用する"
    },
    "pay_stripe": "確認して支払う",
    "terms": "サブスクリプションを確認することで、Linguise が当社の規約に従って将来の支払いを請求することを許可したことになります。サブスクリプションはいつでもキャンセルできます。",
    "coupon": {
      "title": "クーポンをお持ちですか？",
      "placeholder": "ここにクーポンコードを入力してください",
      "apply": "適用する",
      "percent": "{{0}}% オフ"
    },
    "add_new": "新規追加",
    "use_existing": "既存の支払い方法を使用する",
    "recurring": {
      "month_single": "毎月請求される",
      "month_many": "{{count}} か月ごとに請求されます",
      "year_single": "毎年請求される",
      "year_many": "{{count}} 年ごとに請求されます",
      "day_single": "毎日請求される",
      "day_many": "{{count}} 日ごとに請求されます",
      "week_single": "毎週請求される",
      "week_many": "{{count}} 週間ごとに請求されます"
    },
    "add_new_no_stripe": "新しいカードを追加する",
    "summary": {
      "title": "まとめ",
      "subtotal": "小計",
      "total": "合計"
    }
  },
  "dashboard": {
    "main": {
      "title": "ダッシュボード"
    },
    "statistics": {
      "main_title": "過去30日間の統計",
      "characters": "翻訳された文字",
      "words": "翻訳された単語",
      "bandwidth": "入力帯域幅",
      "request": "リクエスト",
      "page_views": "言語ごとのページビュー（過去30日間）",
      "multilingual_views": "多言語ページビュー（過去30日間）",
      "most_page_viewed": "20最も閲覧されたページ（過去30日間）",
      "no_data_yet": "まだご利用可能なデータはありません",
      "th_language": "言語",
      "th_page_views": "ページビュー",
      "real_visitors": "実際の訪問者",
      "crawler": "ウェブクローラー"
    },
    "planHints": {
      "subscribeButton": "申し込む",
      "upgradeButton": "アップグレード",
      "usedWords": "現在 {words_used} 単語です",
      "noPlan": "このドメインではアクティブ化されたプランはありません。 プランを購読して、ウェブサイトの翻訳を開始してください",
      "trialUsage": "現在、あなたがトライアルプランに含まれている{words_allowed}単語の{words_used}単語を使用しています。",
      "trialEnds": "最初の 1 か月のトライアルは、{trial_ends}。",
      "subscribeMessage": "ウェブサイトの翻訳を維持するのめに終了する前に購読してください",
      "trialReachedLimit": "試用期間中、あなたが翻訳された単語の最大数に達しました。\nあなたのウェブサイトを翻訳し続けるのにあるプランの1つを購読してください。",
      "paidUsage": "あなたのプランの{words_used} / {words_allowed}の翻訳された単語を使用しました。",
      "paidReachedLimit": "あなたが現在のプランの最大翻訳単語数に達しました。\nプランをアップグレードして、ウェブサイトの内容の翻訳を続けてください。",
      "trialOfferedUsage": "現在、トライアルプランに含まれている{words_allowed}単語の{words_used}単語を使用しています。（{free_words}が提供する単語を含む）",
      "paidOfferedUsage": "計画で{words_used} / {words_allowed}の翻訳された単語を使用しました。（{free_words}が提供する単語を含む）",
      "noPlanExtra": "非アクティブなドメインとそのデータは定期的に自動的に削除されることに注意してください。",
      "planRecommended": "現在の翻訳量に基づいて推奨されるプランは次のとおりです。:",
      "planMaximumWords": "{{words}} 言葉",
      "notHaveTranslatedWords": "まだ翻訳を行っていません",
      "noPlanShopify": "このドメインではプランが有効になっていません。Shopifyダッシュボードでプランを登録して、ウェブサイトの翻訳を開始してください。",
      "subscribeMessageShopify": "ウェブサイトの翻訳を継続するには、終了する前にShopifyダッシュボードから登録してください。"
    },
    "translationSetup": {
      "kicker": "サブドメインの設定",
      "title": "翻訳設定を確認",
      "description": "DNS、翻訳済みホスト、元のサイトへのアクセス、アカウント上限を確認します。",
      "starting": "確認中...",
      "button": "設定を確認",
      "viewLatest": "最新の結果を表示",
      "viewCurrent": "現在のチェックを表示",
      "runAgain": "再チェック",
      "viewDetails": "詳細を表示",
      "hideDetails": "詳細を非表示",
      "error": "設定を確認できません",
      "allPassed": "すべてのチェックに合格しました",
      "setupNeedsAttention": "設定に確認が必要です",
      "setupNeedsAttentionDescription": "一つ以上のチェックに失敗しました。以下の項目を確認するか、Linguise サポートにお問い合わせください。",
      "lastChecked": "最終確認 {{time}}",
      "domainOwnership": "ドメインの所有権",
      "domainOwnershipDescription": "確認レコードが見つかりました",
      "domainOwnershipFailure": "所有権を確認する DNS レコードを検証できませんでした。",
      "translatedHosts": "翻訳済みホスト",
      "translatedHostsDescription": "{{count}} 個の言語ホストを確認",
      "translatedHostsFailure": "一つ以上の言語 CNAME レコードが正しくありません。",
      "subdomainPage": "サブドメインページ",
      "subdomainPageDescription": "{{count}} 件の翻訳ページが HTTPS を受け付けています",
      "subdomainPageFailure": "翻訳ページを開く際に TLS 接続に失敗しました。",
      "originalSite": "元のサイト",
      "originalSiteDescription": "元のサイトの DNS、TLS、応答チェック",
      "originalSiteFailure": "元のサイトの DNS、TLS、または応答チェックに失敗しました。",
      "documentationAdvice": {
        "dns": "DNS 設定を確認",
        "tls": "HTTPS 設定を確認",
        "origin": "元のサイトの設定を確認",
        "diagnostic": "トラブルシューティング手順を確認"
      },
      "evidence": {
        "originDns": "元の DNS",
        "originTls": "元の TLS",
        "originHttp": "元の応答",
        "observedTargets": "検出された接続先",
        "recordCount": "見つかったレコード",
        "addressCount": "見つかったアドレス",
        "statusCode": "HTTP ステータス",
        "redirect": "リダイレクト",
        "expiresAt": "証明書の有効期限",
        "raw": "{{key}}",
        "noValue": "値なし"
      },
      "checkerError": "一部のチェックを完了できませんでした。",
      "coreLocation": "{{location}} から確認",
      "status": {
        "queued": "待機中",
        "running": "実行中",
        "completed": "完了",
        "failed": "失敗",
        "passed": "合格",
        "warning": "警告",
        "unknown": "不明",
        "skipped": "スキップ",
        "not_applicable": "該当なし"
      }
    },
    "throttling": {
      "title": "翻訳の利用制限",
      "description": "一時的な利用制限",
      "unavailable": "一時的な翻訳制限を利用できません",
      "window": "{{used}} / {{max}} 語",
      "resetsIn": "{{time}} 後にリセット",
      "throttled": "翻訳は一時停止中です",
      "throttledDescription": "一時的な利用上限に達しました。この期間がリセットされると翻訳が再開されます。"
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "ステップ {{step}} から {{total}}",
      "doneLabel": "済み、翻訳を開始できる。",
      "finish": {
        "title": "",
        "description": "これはウェブサイトで使用するAPIキー"
      },
      "instructions": "インストール手順",
      "domainSetting": "ドメイン設定",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "スクリプトPHP",
        "wizardWordpressStep1": "1. をインストールします。 ",
        "wizardWordpressStep2": "\n 2. プラグインの設定で、APIキーをコピーして入力します。\n",
        "wizardWordpressStep3": "3. 翻訳の準備ができました\n\n",
        "wizardWordpressStep4": "より詳しい説明は、ドキュメントをご覧ください。: ",
        "wizardJoomlaStep1": "1. Joomlaパッケージリンク: ",
        "wizardJoomlaStep2": "\n2. 拡張機能の設定では、APIキーをコピーして入力します。",
        "wizardJoomlaStep4": "\n 4. 翻訳の準備ができました\n\n",
        "wizardJoomlaStep3": "3. モジュールの設定では、表示したい言語を設定し、必要な場所にモジュールを挿入します。",
        "wizardPhpStep1": "1. phpスクリプトのダウンロードはこちら ",
        "wizardPhpStep2": "\n2. こちらのドキュメントページのインストール手順に従ってください。 ",
        "wizardPhpStep3": "\n3. モジュールをページに追加します。",
        "wizardPhpStep4": "\n 以下のコードをコピーしてHTMLページの先頭に追加すると、自動的にスイッチャーモジュールが表示されます。\n",
        "dispatchStep1": "必要なデータを Linguise プラグインに正常に送信しました。次のウィンドウを閉じることができます。",
        "dispatchStep2": "このウィンドウを閉じるときにトークンが見つからない場合は、次のトークンをコピーしてください。",
        "dispatchStep3": "このスニペットをコピーして、フラグスイッチャーを自動的に有効にすることもできます。",
        "wizardOtherStep1": "ドメインに Linguise をインストールするには、以下の手順に従ってください。",
        "wizardOtherStep2": "次のコードをコピーして HTML ページの先頭に追加すると、スイッチャー モジュールが自動的に表示されます。"
      },
      "trialAlreadyUsed": "すでに無料トライアルを使用しているようなので、翻訳クォータを取得する必要がある\n試用期間を延長する必要がある場合は、プランをサブスクライブするか、お問い合わせください。",
      "usefulLinks": "便利なリンクを始める",
      "linkDocumentation": "ドキュメンテーション",
      "linkExtensionDl": "ダウンロードの拡張",
      "linkSubscribe": "今すぐプランを購読する",
      "linkDashboard": "ダッシュボードに移動する",
      "exclusion": {
        "title": "会社と製品の名前",
        "description": ""
      },
      "finishButton": "セットアップを完了する",
      "subdomains": "サブドメイン",
      "subdomain_setup": "ドメインのセットアップ",
      "subdomain_auto_setup": "DNS を自動的に接続する",
      "subdomain_manual_setup": "DNS エントリを自分で追加する",
      "subdomain_skip": "DNS エントリを自分で追加する",
      "auto_subdomains_info": "サイトビルダー CMS には、サブドメイン (例: ja.domain.com) ごとに言語を設定するための DNS 構成が必要です。 Entri を使用すると、これを自動的に行うことができます。 「DNS を自動的に接続する」ボタンをクリックするだけで、DNS マネージャーへの接続が開始され、Entri に DNS マネージャーが追加されます。 ",
      "auto_subdomains_info_manual": "または、[DNS エントリを自分で追加する] ボタンをクリックして、ドメインを手動で構成することもできます。",
      "auto_subdomains_info_2": "Entri を使用すると、これを自動的に行うことができます。 [DNS を自動的に接続する] ボタンをクリックするだけで、DNS マネージャーへの接続が開始され、Entri に DNS マネージャーが追加されます。 ",
      "breadcrumbs": {
        "step1": "ステップ1：ドメイン、CMS、言語",
        "step2": "ステップ2: 言語DNS",
        "step3": "ステップ {{step}}: インストール手順"
      }
    },
    "form": {
      "urls": {
        "dash": "ダッシュ -",
        "underscore": "アンダースコア _",
        "title": "URLを翻訳する",
        "description": "全てのページで翻訳しますか",
        "char_description": "使用する文字はURL内の許可されていない文字を置き換える",
        "advertisement_title": "⚠ たくさんの言語が設定されていますが、どのようにしたらいいですか？\n",
        "advertisement": "通常、最初は言語数の少ないウェブサイトの翻訳を始めることをお勧めしています。そうすることで、お客様のウェブサイトにどれくらいの文字数があるのかを把握することができます。\nまた、ページ数が少ない方が、Googleボットのクロールが早くなるので、SEO的にも有利です。\n1週間後には、さらにいくつかの言語を追加していきます。"
      },
      "url": {
        "title": "Url",
        "description": "http:// か https://から始まるメインドメインのURLを入力する",
        "placeholder": "ドメイン　URL",
        "advertisement_http": {
          "title": "httpsプロトコルを使用していません",
          "description": "ドメインが実際にhttpsプロトコルを使用していないことを確認してください。これは現在推奨されています。"
        },
        "advertisement_www": {
          "title": "あなたのサブドメインはwwwではありません",
          "description": "ほとんどの場合、デフォルトのサブドメインはwwwです（https://www.mydomain.comなど）。 これはあなたのケースではないかもしれませんが、追加したいドメインが正しいものであることを再確認してください。"
        },
        "invalid_url": {
          "line1": "あなたのドメインが見つかりませんでした。 ドメインがインターネット経由でパブリックにアクセス可能であり、別の場所にリダイレクトされていないことを確認してください。 ",
          "line2": "ドメインにアクセスできることが確実な場合は、ドメインの検証をスキップして、もう一度「次のステップ」ボタンを押してください。",
          "contact": "いずれの場合でも、次のアドレスまでご連絡ください。",
          "force": "ドメイン検証をスキップする"
        },
        "invalid_subdomain_url": "このURLは許可されていません。サブドメインはhttps://www.domain.tldまたはサブディレクトリなしのhttps://domain.tldの形式で指定する必要があります。"
      },
      "account": {
        "title": "アカウント",
        "description": "このドメインを割り当てるアカウントを選択してください",
        "placeholder": "アカウントを選択...",
        "feedback": "アカウントを選択する必要があります"
      },
      "platform": {
        "title": "プラットホーム",
        "description": "CMS 名で Web サイトのプラットフォームを選択してください.",
        "learn": "選び方を学ぶ",
        "placeholder": "CMS 名でプラットフォームを検索...",
        "info": {
          "title": "⚠ このプラットフォームは最近追加されました。\n",
          "desc": "この Web サイト ビルダー プラットフォームは Linguise でサポートされていますが、最近追加されたものです。 問題が発生した場合は、直接サポート メールを使用してご連絡ください。"
        },
        "description_read_only": "ウェブサイトが使用しているプラ​​ットフォーム",
        "feedback": "プラットフォームを選択する必要があります"
      },
      "language": {
        "title": "言語",
        "description": "あなたのウェブサイトの基本言語を選択してください",
        "placeholder": "言語を選択する...",
        "feedback": "あなたは言語を選択する必要がある",
        "description_read_only": "あなたのウェブサイトの基本言語"
      },
      "token": {
        "title": "APIキー",
        "description": "これはあなたのウェブサイトのコピーするために使うAPIキーです",
        "copy": "クリップボードにコピーする",
        "reset": "APIキーのリセット",
        "reset_confirm": "API Keyがリセットされていることを確認してください。"
      },
      "languages": {
        "title": "翻訳言語",
        "description": "あなたのウェブサイトを翻訳できるようにしたい言語を選択する",
        "placeholder": "言語を選択する...",
        "feedback": "言語を選択する必要がある"
      },
      "defaultRules": {
        "title": "デフォルトのルール",
        "description": "WordPressダッシュボードのように、翻訳を強化し、不要なコンテンツが翻訳されないようにするために、一連の必須ルールを定義しました。\n必要に応じて、後でこれらのルールを削除または編集できます。"
      },
      "disallow_deletion": "アクティブなサブスクリプションを持つドメインを削除することはできません。",
      "delete_confirm": "ドメインの削除を確認してください",
      "delete": "ドメインを削除する",
      "dynamic": {
        "title": "動的コンテンツの翻訳",
        "description": "JavaScript および AJAX リクエストによって生成された動的コンテンツが翻訳されます (このオプションにより、翻訳の使用量が増加します)"
      },
      "partial_translations": {
        "title": "部分的な翻訳を許可する",
        "description": "アカウントが翻訳クォータに達しているにもかかわらずページの翻訳が必要な場合、Linguise は翻訳済みのコンテンツを含むページを引き続き表示できます。ただし、クォータをアップグレードするまで、ページの一部は未翻訳のままになります。通常、少量の未翻訳コンテンツが SEO に悪影響を与えることはありませんが、未翻訳コンテンツが多すぎると、ユーザー エクスペリエンスに悪影響を及ぼす可能性があります。これに対処するために、ページ上で許可される未翻訳コンテンツの割合のしきい値を設定できます。未翻訳のコンテンツがこのしきい値を超えると、ユーザーは自動的に元の言語バージョンのページにリダイレクトされます。",
        "never": "一度もない"
      },
      "translate_error_pages": {
        "title": "エラーページを翻訳する",
        "description": "Linguise はすべてのエラー ページを翻訳できますが、エラー ページに IP アドレスやリクエスト ID などの動的なコンテンツが含まれている場合は、これらのページの翻訳を避ける必要があります。",
        "not_found_page": {
          "title": "404ページを翻訳"
        },
        "error_page": {
          "title": "他のエラーページを翻訳する"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "既存のドメインが見つかりました",
          "description": "このユーザーの既存のドメインが見つかりました。それを使用しますか?"
        }
      },
      "search_tl": {
        "title": "翻訳を検索",
        "description": "ウェブサイトプラットフォームの検索翻訳を有効にする（試験的、このオプションにより翻訳の利​​用が増えます）"
      },
      "shopify_promo": {
        "info": "朗報です！ShopifyアプリストアからインストールできるShopifyネイティブアプリができました。",
        "hyperlink": "ここをクリックして、アプリからLinguiseをインストールしてください。",
        "next_btn": "アプリをインストールするにはShopifyストアにアクセスしてください",
        "info_legacy": "朗報です！ShopifyアプリストアからインストールできるShopifyネイティブアプリができました。",
        "description_legacy": "「Shopify Legacy」ではなく「Shopify」プラットフォームを選択してください"
      },
      "wix_promo": {
        "info": "朗報です！WixアプリマーケットからインストールできるWixネイティブアプリができました。",
        "hyperlink": "ここをクリックして、アプリからLinguiseをインストールしてください。",
        "next_btn": "アプリをインストールするにはWixアプリマーケットにアクセスしてください",
        "info_legacy": "朗報です！WixアプリマーケットからインストールできるWixネイティブアプリができました。",
        "description_legacy": "「Wix Legacy」ではなく「Wix」プラットフォームを選択してください"
      },
      "ai_disallow_deletion": "AIクォータがまだ残っている間は、このドメインを削除することはできません。このドメインを削除したい場合は、サポートチームまでご連絡ください。",
      "language_removal": {
        "card": {
          "title": "削除した言語の翻訳を削除",
          "description": "ウェブサイトから削除した言語の翻訳が保存されており、引き続き使用枠にカウントされています。削除すると、その分の単語数が使用枠に戻ります。",
          "button": "翻訳を削除"
        },
        "hint": "使用された単語数は使用枠に戻ります。各ウェブサイトで {{days}} 日ごとに 1 回実行できます。",
        "modal": {
          "title": "翻訳を削除しますか？",
          "intro": "次の翻訳は完全に削除されます：",
          "warning": "この操作は取り消せません。使用された単語数が使用枠に戻るまで、数分かかる場合があります。",
          "limit": "各ウェブサイトで {{days}} 日ごとに 1 回実行できます。",
          "confirm": "翻訳を削除"
        },
        "scheduled": "翻訳を削除しています。まもなく使用枠が更新されます。",
        "cooldown": "このウェブサイトの翻訳は最近削除されました。{{date}} 以降に再度削除できます。",
        "latest_completed": {
          "title": "直近の削除完了",
          "description": "削除した言語と使用枠に戻った単語数を確認できます。",
          "languages": "削除した言語",
          "words_returned": "使用枠に戻った単語数：{{words}}",
          "completed_at": "{{date}} に完了"
        },
        "status": {
          "recent_title": "最近の翻訳削除",
          "recent_description": "直近の削除状況と次回の実行可能時期を確認できます。",
          "progress_title": "削除の進行状況",
          "loading": "削除の進行状況を確認しています...",
          "unavailable": "削除の進行状況を読み込めませんでした。ページを更新してもう一度お試しください。",
          "label": "ステータス",
          "pending": "待機中",
          "processing": "処理中",
          "completed": "完了",
          "failed": "失敗",
          "unknown": "ステータスを確認できません",
          "percent": "{{percent}}% 完了",
          "current_stage": "現在の手順：{{stage}}",
          "processed": "{{processed}} 件を処理済み",
          "processed_total": "{{total}} 件中 {{processed}} 件を処理済み",
          "requested_at": "{{date}} にリクエスト",
          "started_at": "{{date}} に開始",
          "completed_at": "{{date}} に完了",
          "cooldown_period": "各ウェブサイトで {{days}} 日ごとに 1 回実行できます。",
          "cooldown_blocked": "まだ次の削除を開始できません。",
          "stage": {
            "queued": "開始待ち",
            "processing": "処理中",
            "refund_summary": "返還される単語数を計算中",
            "search_translations": "検索翻訳を削除中",
            "url_translations": "URL 翻訳を削除中",
            "translations": "翻訳を削除中",
            "completed": "完了",
            "failed": "失敗",
            "unknown": "処理中"
          }
        },
        "forbidden": "翻訳を削除する権限がありません。"
      }
    },
    "main": {
      "edit": "ドメインを編集する",
      "add": "ドメインを追加する",
      "wizard": "ようこそ！新しいドメイン作成ウィザード",
      "common": "ドメイン"
    },
    "subdomains": {
      "config_ok": "サブドメイン DNS が正しく設定されています。",
      "config_invalid": "サブドメイン DNS が機能するには、追加の構成が必要です。",
      "config_check": "サブドメインの DNS 設定をチェック中です。お待​​ちください...",
      "entri_timeout": "Entri は、サブドメイン DNS 伝達プロセスがタイムアウトした、再試行する必要がある、または手動で実行できると報告しました。",
      "entri_process": "DNS は Entri で追加されており、反映には通常 10 ～ 30 分かかります (ja.domain.com などのすべての言語のサブドメインを適用します)。 DNS 検証が 24 時間経っても完了しない場合は、サポート チームにご連絡ください: support@linguise.com ",
      "entri_ok": "DNS の伝播が進行中です。 伝播を待っています... ",
      "infos": "翻訳を有効にするには、これらのDNSエントリをDNSドメインレコードに追加する必要があります。完了したらチェックボタンをクリックしてください。DNSレコードの反映には時間がかかる場合がありますので、数分または数時間後に再度確認をお願いいたします。",
      "check": "DNS設定を確認する"
    },
    "notice": {
      "broken_card": "現在のお支払い方法を使用して {{url}} のプランを更新できませんでした。お支払いカードを更新してください",
      "quota_reached": "{{url}} の翻訳割り当てに達しました。ウェブサイトの翻訳を再開するにはアップグレードしてください。",
      "important": "重要",
      "quota_reached_button": "今すぐプランをアップグレードしてください",
      "broken_card_button": "支払いカードを更新する",
      "ai_no_subscription": "{{url}} の AI 翻訳には、有効なサブスクリプションまたは有効なトライアルが必要です。サブスクリプションまたはトライアルがない場合、翻訳は停止します。続行するにはアップグレードしてください。",
      "ai_no_subscription_button": "今すぐプランをアップグレード",
      "quota_warning": "{{url}} の翻訳クォータが {{throttling_used_percent}}% に達しました。これは {{ttl}} 後にリセットされます。",
      "locked": "ドメイン {{url}} は現在移行のためにロックされています。サイトには引き続きアクセスできますが、編集したり新しい翻訳を追加したりすることはできません。"
    },
    "subscription": {
      "next_payment_amount": "今後の料金",
      "next_payment_date": "次回支払日",
      "invoice": {
        "header": "請求書履歴",
        "date": "日付",
        "amount_due": "額",
        "status": "状態",
        "actions": "アクション",
        "description": "トランザクションが利用可能になったら、ここで表示できます。",
        "status_text": {
          "draft": "下書き",
          "open": "保留中",
          "paid": "有料",
          "uncollectible": "収集不可能",
          "void": "空所",
          "failed": "失敗した",
          "retrying": "再試行"
        },
        "view": "ビュー",
        "empty": "このサブスクリプションについては、最近の請求書は見つかりません",
        "retry_payment": "リトライ"
      },
      "next_cancellation": "キャンセル日",
      "cancel": "サブスクリプションをキャンセルする",
      "change_plan": "計画の変更",
      "change": "変化",
      "suspend": "支払いを一時停止する",
      "resume": "サブスクリプションを再開する",
      "back": "戻る",
      "save": "保存",
      "confirm_resume": "このサブスクリプションを再開してもよろしいですか?",
      "confirm_cancel": "このサブスクリプションをキャンセルしてもよろしいですか?",
      "confirm_header": "本気ですか？",
      "missing_status": "このサブスクリプションはありません",
      "not_found": "このドメインのサブスクリプションが見つかりません",
      "no_payment_method": "未知",
      "remove_billing": "取り除く",
      "confirm_manual_retry": "この支払いを再試行してもよろしいですか?",
      "shopify_maneged": "このサブスクリプションはShopifyによって管理されています。Shopify管理パネルから管理してください。",
      "unknown_plan": "不明なプラン"
    }
  },
  "domain_listing": {
    "select": "ドメインを選択する",
    "add": "ウェブサイトを追加する"
  },
  "editable": {
    "number": "番号 {{id}}"
  },
  "footer": {
    "about": "について",
    "support": "サポート"
  },
  "frontendEditor": {
    "main": "ライブエディター",
    "description": "ライブエディタがウエブサイトの翻訳を直接編集できるように手伝います。",
    "button": "ライブエディタを開く",
    "language_selection": "翻訳言語の選択",
    "video_label": "ライブエディターの使用方法を学ぶ"
  },
  "general": {
    "403": {
      "tab_title": "おっと - 403 エラー",
      "title": "アクセスが拒否されました",
      "message": "要求されたページにアクセスできないようです。",
      "home": "帰宅"
    },
    "404": {
      "tab_title": "おっと-404エラー",
      "title": "ページが見つかりません",
      "message": "あなたが間違った方向に進んだようです。 心配しないでください... 線路に戻るのに役立つちょっとしたヒントがあります。",
      "home": "ホームに戻る"
    },
    "500": {
      "tab_title": "500 エラー",
      "title": "内部サーバーエラー",
      "message": "ページを更新してみませんか？ または私達に連絡することができます",
      "home": "ホームに戻る"
    },
    "fields": {
      "alert": "一部のフィールドが無効なので無効なフィールドを修正してください。",
      "invalid": "このフィールドは無効です。",
      "phone_re": "電話番号が無効です",
      "phone_invalid": "電話番号は無効です",
      "email": "メールアドレスが無効です"
    },
    "saving": "保存中 ...",
    "save": "保存",
    "save_and_quit": "保存して終了",
    "invite": "招待する",
    "cancel": "キャンセル",
    "yes": "はい",
    "no": "いいえ",
    "nextStep": "次のステップ",
    "loading": "アプリケーションが読み込まれるまでお待ちください",
    "goback": "戻る",
    "manage": "管理",
    "delete": "削除",
    "deleting": "削除中 ...",
    "table": {
      "no_data": "ここにはまだデータがありません..."
    },
    "confirm": "確認する",
    "unknown": "不明",
    "hide": "隠れる",
    "show": "見せる",
    "on": "の上",
    "off": "オフ",
    "default": "デフォルト"
  },
  "home": {
    "header": "ホームホーム",
    "manage": "サブスクリプションを管理する",
    "activate_now": "今すぐアクティブ化する",
    "activate_plan_now": "今すぐ購読する",
    "upgrade_plan_now": "今すぐアップグレードプランを",
    "trial_message_part_1": "現在お試しプランをご利用中ですが、 ",
    "trial_message_part_2": "メンバーシップはいつでもアクティブ化できます。",
    "add": "ドメインを追加",
    "table": {
      "title": "ドメイン",
      "description": "ドメインのリスト。ドメインをクリックして翻訳を管理します"
    },
    "domains": {
      "empty": "このアカウントにはドメインがありません"
    },
    "accountsList": {
      "title": "アカウント",
      "add": "新しいアカウントを追加する",
      "name": "アカウント名"
    },
    "update_credit_card": "クレジットカードの詳細を更新する",
    "canceled": "サブスクリプションがキャンセルされました",
    "cancelling_subs": "{{0}}でキャンセルします",
    "resume_subscription": "サブスクリプションを再開する",
    "shopify_managed": "Shopifyによる管理",
    "trial_ends_at": "{{0}}に終了",
    "free_trial": "無料トライアル",
    "no_subs": "アクティブなサブスクリプションなし"
  },
  "invoices": {
    "title": "請求書",
    "list": {
      "title": "請求書のリスト"
    },
    "table": {
      "customer": "お客様",
      "domain": "ドメイン",
      "amountPaid": "払込金額",
      "status": "ステータス",
      "date": "日付",
      "invoice": "請求書",
      "pay": "請求書の支払い",
      "actions": "アクション",
      "deleted_domain": "ドメインが削除されました",
      "plan_name": "プラン",
      "action": "アクション"
    },
    "listPending": {
      "title": "保留中の請求書リスト"
    }
  },
  "language_settings": {
    "display": "言語一覧表示",
    "position": "位置",
    "display_help_text": "国旗や言語名を表示します。 言語スイッチャーのデフォルトの位置は、コンテンツ内の任意の場所、または固定されたままになるかスクロールに応じて移動する固定位置にすることができます。",
    "side_by_side": "並んで",
    "dropdown": "落ちる",
    "popup": "現れる",
    "flag": "国旗",
    "lang_name": "言語名",
    "lang_short_name": "短い名前",
    "positions": {
      "in_place": "所定の位置に",
      "top_left": "左上",
      "top_left_no_scroll": "左上 (スクロールなし)",
      "top_right": "右上",
      "top_right_no_scroll": "右上 (スクロールなし)",
      "bottom_left": "左下",
      "bottom_left_no_scroll": "左下（スクロールなし）",
      "bottom_right": "右下",
      "bottom_right_no_scroll": "右下 (スクロールなし)"
    },
    "lang_names_display": {
      "title": "言語名の表示",
      "help_text": "言語スイッチャーで、言語名を英語または元の言語 (フランス語または Français) で表示します。",
      "english": "英語",
      "native_languages": "母国語"
    },
    "flag_shape": {
      "title": "旗のスタイル",
      "help_text": "丸い SVG または長方形の SVG フラグ アイコンを使用する",
      "round": "ラウンド",
      "rectangular": "長方形"
    },
    "english_flag_type": {
      "title": "英語の国旗の種類",
      "help_text": "英語にはイギリスまたはアメリカの国旗を使用してください",
      "usa": "アメリカの国旗",
      "great_britain": "イギリスの国旗"
    },
    "german_flag_type": {
      "title": "ドイツの国旗の種類",
      "help_text": "ドイツ語にはオーストリアまたはドイツの国旗を使用します",
      "german": "ドイツの国旗",
      "austria": "オーストリアの国旗"
    },
    "spain_flag_type": {
      "title": "スペイン国旗の種類",
      "help_text": "スペイン語にはメキシコまたはスペインの国旗を使用します",
      "spanish": "スペインの国旗",
      "mexico": "メキシコの国旗",
      "peruvian": "ペルーの国旗"
    },
    "portugal_flag_type": {
      "title": "ポルトガルの国旗の種類",
      "help_text": "ポルトガル語にはポルトガル国旗またはブラジル国旗を使用します",
      "portugal": "ポルトガルの国旗",
      "brazil": "ブラジルの国旗"
    },
    "taiwanese_flag_type": {
      "title": "台湾の国旗の種類",
      "help_text": "台湾人には台湾国旗または中国国旗を使用します",
      "taiwanese": "台湾の国旗",
      "chinese": "中国の国旗"
    },
    "flag_border_radius": {
      "title": "旗の境界線の半径 (px)",
      "help_text": "長方形の旗の形状を使用している場合は、カスタムの境界線の半径をピクセル単位で適用できます"
    },
    "flag_width": {
      "title": "フラグのサイズ (px)",
      "help_text": "フラグのサイズをピクセル単位で選択します。 .svg 形式であるため、画像の重みは変わりません"
    },
    "lang_color": {
      "color_title": "言語名の色",
      "color_help_text": "言語名のデフォルトのテキストの色を選択します",
      "hover_color_title": "言語名のホバー色",
      "hover_color_help_text": "言語名のマウス ホバー テキストの色を選択します",
      "color_popup_title": "ポップアップ言語の色",
      "color_popup_help_text": "ポップアップまたはドロップダウン領域の言語タイトルの色",
      "hover_color_popup_title": "ポップアップ言語のホバー色",
      "hover_color_popup_help_text": "ポップアップまたはドロップダウン領域で言語タイトルのマウス ホバー テキストの色を選択します。"
    },
    "flag_box_shadow": {
      "shadow_title": "フラグボックスの影",
      "shadow_help_text": "言語フラグの色と影のサイズ",
      "hover_shadow_title": "ホバー時のフラグ ボックスの影",
      "hover_shadow_help_text": "マウスオーバー時の言語フラグの色と影のサイズ",
      "shadow_h_offset": "シャドウの H オフセット (px)",
      "shadow_v_offset": "シャドウ V オフセット (px)",
      "shadow_blur": "影のぼかし (px)",
      "shadow_spread": "影の広がり (ピクセル)",
      "shadow_color": "影の色"
    },
    "order": "言語の順序",
    "language_order_help": "言語スイッチャーに表示される言語の順序。 言語をドラッグ アンド ドロップして並べ替えることができます。 ",
    "order_reset": "順序をリセットする",
    "language_order_dragdrop": "言語をドラッグ アンド ドロップして並べ替えることができます。",
    "popup_lang_name": "ポップアップ言語名",
    "preview": "言語プレビュー"
  },
  "link": {
    "form": {
      "original": {
        "title": "元のソース",
        "description": "元のリンク URL を追加し、以下を言語に置き換えて翻訳します",
        "srcset_description": "画像URLを編集しています。srcsetを使用する場合や、srcsetが何かわからない場合は、必ずドキュメントをお読みください",
        "link": "リンク",
        "match_link": "マッチモード",
        "match_exact": "ちょうど",
        "match_wildcard": "ワイルドカード",
        "match_regex": "正規表現"
      },
      "alternative_languages": {
        "title": "置き換えるリンク",
        "description": "言語ごとに、ページ全体のメディア リンクと外部リンクを置き換えます…",
        "link": "交換するリンク"
      },
      "error": {
        "atLeastOne": "少なくとも 1 つの翻訳を追加してください。",
        "url": "URL が無効です",
        "extension": "リンクには拡張子が必要ですが、.html や .php にすることはできません。 また、リンクには言語パスを含めないでください。 \"/fr\"",
        "regex": "正規表現が無効です",
        "wildcard": "ワイルドカードリンクに無効なプロトコルがあります"
      }
    },
    "main": {
      "parent": "リンク",
      "edit": "リンクを編集"
    }
  },
  "links": {
    "title": "メディアと外部リンクの管理",
    "description": "ウェブサイトのメディア リンクまたは外部リンクを一覧表示および編集します。",
    "add": "リンクを追加",
    "delete": "リンクを削除",
    "table": {
      "original": "オリジナル",
      "language": "言語",
      "translation": "翻訳",
      "action": "アクション",
      "delete_confirm": "リンクの削除を確認してください"
    }
  },
  "members": {
    "header": "メンバー",
    "invite": "新しいメンバーを招待する",
    "modal": {
      "inviteHeader": "新しいメンバーを招待する",
      "editHeader": "メンバーの編集",
      "detachHeader": "メンバーを切り離す",
      "detachBody": "このアカウントからメンバーを削除してもよろしいですか?",
      "selfDetachBody": "このアカウント管理から切り離してもよろしいですか? その後、このアカウントに関連するデータにはアクセスできなくなります。 "
    },
    "table": {
      "title": "メンバーリスト",
      "description": "メンバーの役割とドメインへのアクセス",
      "name": "名前",
      "email": "Eメール",
      "websites": "ウェブサイト",
      "languages": "言語",
      "role": "役割",
      "status": "状態",
      "resendInvite": "再送信する",
      "inviteSent": "招待状が送信されました",
      "actions": "行動",
      "edit": "編集",
      "detach": "切り離す",
      "empty": "まだメンバーがいません",
      "all_website": "すべてのウェブサイトと言語",
      "roles": {
        "admin": "管理者",
        "manager": "マネージャー",
        "translator": "翻訳者"
      },
      "statuses": {
        "pending": "保留中",
        "accepted": "受諾済み",
        "declined": "拒否された"
      }
    },
    "errors": {
      "role": "役割を選択する必要があります",
      "domains": "選択した役割に対して少なくとも 1 つの Web サイトを選択する必要があります",
      "languages": "選択した Web サイトには少なくとも 1 つの言語を選択する必要があります"
    },
    "inviteSent": "招待状は正常に送信されました"
  },
  "pagination": {
    "showing": "{{total}}結果の {{limit}} を示しています",
    "showing_only_count": "{{limit}} を示しています"
  },
  "payments_method": {
    "header": "お支払い方法",
    "table": {
      "title": "お支払い方法一覧",
      "description": "アカウントに関連付けられた支払い方法",
      "default": "デフォルト",
      "action_edit_remove": "編集または削除",
      "action_remove": "取り除く",
      "action_default": "デフォルトとして設定",
      "action_fallback": "フォールバックとして設定",
      "expires": "有効期限",
      "add_new_card": "支払い方法を追加する",
      "action_fallback_remove": "フォールバックから削除",
      "fallback": "後退する",
      "action_edit": "編集",
      "action_delete": "消去",
      "action_default_remove": "デフォルトとして削除",
      "domain_count@@one": "{{count}}ドメインによって使用されます",
      "domain_count@@other": "{{count}} 個のドメインで使用されています"
    },
    "paypal_bind": {
      "button": "PayPal アカウントを接続する",
      "button_load": "接続中...",
      "disconnected": "接続されていません",
      "error": "エラーが発生しました",
      "success_header": "成功",
      "success_no_promo": "PayPal アカウントが接続されました",
      "success": "PayPal アカウントが接続されました。次回の請求書から 5 ドルが差し引かれます。"
    },
    "card_add": {
      "header": "新しいカードを追加する",
      "success": "新しいカードを Linguise に接続しました!",
      "terms": "カード情報を提供することにより、Linguise がサービス規約に従って将来の支払いをカードに請求することを許可することになります。"
    },
    "card_detail": {
      "header": "カード情報",
      "delete": {
        "error": "この支払い方法にはアクティブなサブスクリプションがあるため、削除できません。"
      }
    },
    "subscriptions": {
      "table": {
        "description": "このお支払い方法での定期購入",
        "header_domain": "ドメイン",
        "header_plan": "プラン",
        "header_status": "状態",
        "header_actions": "アクション",
        "cancelling": "キャンセル: {{0}}",
        "next_payment": "次回のお支払い: {{0}}",
        "action_renew": "更新する",
        "no_subs_header": "表示するサブスクリプションはありません",
        "no_subs_desc": "このカードを購読すると、すべての情報がここに表示されます",
        "action_manage": "管理"
      },
      "status": {
        "active": "アクティブ",
        "canceled": "キャンセル",
        "incomplete": "未払い",
        "incomplete_expired": "未払い（期限切れ）",
        "past_due": "期限を過ぎた",
        "trialing": "トライアル",
        "unpaid": "未払い",
        "missing": "エラー"
      }
    },
    "delete_confirm_body": "この支払い方法を削除してもよろしいですか?このアクションは元に戻すことはできません。",
    "delete_confirm_header": "支払い方法を削除しますか?",
    "card_edit": {
      "header": "カードを編集する",
      "billing_header": "請求情報",
      "address_error": "住所は必須です！",
      "card_number": "カード番号",
      "card_expiry": "有効期限",
      "expiry_error_month": "無効な月が指定されました",
      "expiry_error_year": "無効な年が指定されました",
      "expiry_error_expired": "カードの有効期限が過ぎています。",
      "card_header": "カード情報",
      "expiry_error_empty": "この項目は必須です！"
    }
  },
  "plans": {
    "per": "あたり",
    "wordsTranslated": "翻訳された単語",
    "current": "現在の",
    "archived": "アーカイブされた",
    "day": "日",
    "week": "週",
    "month": "月",
    "year": "年",
    "activate": "アクティベート",
    "cancel": "キャンセル",
    "change": "変更",
    "upgrade": "アップグレード",
    "downgrade": "ダウングレード",
    "notEnoughWords": "言葉が足りない",
    "yearIntervalOnly": "年間プランから移行できません",
    "wordsUnlimited": "無制限の言葉",
    "tabs": {
      "day": "毎日の価格",
      "week": "週間価格",
      "month": "月間価格",
      "year": "年間価格",
      "sub_texts": {
        "day": "毎日 1 つの定額料金",
        "week": "毎週 1 回の固定料金",
        "month": "毎月 1 回の固定料金",
        "year": "1 か月無料、1 年に 1 回の請求"
      }
    },
    "details": {
      "new_languages": "新しい言語をいつでも追加できます",
      "one_month_trial": "新しいウェブサイトごとに 1 か月間無料トライアル",
      "multi_content_indexed": "多言語コンテンツの 100% がインデックス化されています",
      "translate_new_content": "新しいコンテンツを即座に翻訳",
      "free_installation": "無料のインストールとセットアップ",
      "compared_monthly_plan": "月額プランと比較して 1 か月間無料",
      "risk_free_recurring": "リスクのない定期的な支払い失敗",
      "unlimited_languages": "無制限の言語とページビュー",
      "high_server_resources": "サーバーリソースが多い",
      "billed": {
        "day": "毎日請求される",
        "week": "毎週請求される",
        "month": "毎月請求される",
        "year": "毎年請求される"
      },
      "request_max_size": "リクエストの最大サイズは{{0}}"
    },
    "frequent_question": {
      "title": "よくある質問",
      "questions": {
        "trial": {
          "question": "新しい Web サイトのドメインで試用版を使用できますか?",
          "answer": "はい、アカウントに新しい Web サイト ドメインを追加するたびに、30 日間の無料トライアルを提供します。 このようにして、新しい Web サイトで翻訳サービスを完全にテストできます。"
        },
        "seo": {
          "question": "SEO が改善されるまでどのくらい時間がかかりますか?",
          "answer": "コンテンツと多言語コンテンツは、完全にインデックス付けされ、適切にランク付けされるまでに時間がかかります。 ウェブサイトのトラフィックとサイズに応じて、3 ～ 6 週間かかります。"
        },
        "quota": {
          "question": "人間による翻訳もノルマに含まれますか?",
          "answer": "いいえ、単語数の制限は自動機械翻訳のみに適用されます。 翻訳者は自動翻訳を無制限に手動で編集できます。"
        }
      }
    },
    "best_offer": "最高の提案",
    "resume": "再開する",
    "subsCanceled": "別のサブスクリプションのキャンセルが進行中です",
    "period": {
      "days@@one": "1日",
      "days@@other": "{{count}}日",
      "hours@@one": "1時間",
      "hours@@other": "{{count}}時間",
      "minutes@@one": "1分",
      "minutes@@other": "{{count}}分",
      "seconds@@one": "1秒",
      "seconds@@other": "{{count}}秒"
    },
    "words": {
      "billion": "{{value}}0億",
      "million": "{{value}}00万",
      "thousand": "{{value}}千"
    },
    "throttling_info": "{{period}}あたり{{words}}語"
  },
  "profile": {
    "welcome": "ようこそ！",
    "account": "私のアカウント",
    "subscriptions": "サブスクリプション",
    "logout": "ログアウト"
  },
  "register": {
    "errors": {
      "password": "最小8文字、任意の文字"
    }
  },
  "route": {
    "dashboard": "ダッシュボード",
    "rules": "ルール",
    "translations": "翻訳",
    "search_translations": "翻訳を検索",
    "urls_translations": "URLの翻訳",
    "links": "メディアと外部リンク",
    "online_editor": "ライブエディター",
    "settings": "設定",
    "domain": {
      "finish": "設定",
      "preconfig": "設定"
    },
    "home": "家",
    "domain_list": "ドメインリスト",
    "members": "メンバー",
    "invoices": "請求書",
    "billing": "支払明細",
    "language_display": "言語フラグの表示",
    "payment_methods": "お支払い方法",
    "ai_translation": "AI翻訳",
    "ai_translation_settings": "設定",
    "ai_translation_pricing": "価格"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "無視するテキスト",
        "add": "新しく追加する",
        "title": "無視するテキスト",
        "description": "無視する1つまたは複数のテキストを追加する",
        "ignore_case": "ケースを無視する"
      },
      "html_content": {
        "title": "HTMLコンテンツに適用する",
        "description": "コンテンツ全体にルールを適用するか、特定のCSSセレクターを選択する",
        "all_page": "全てのページ",
        "css_selector": "CSSセレクター",
        "label": "CSSセレクター",
        "placeholder": "適用するセレクター",
        "add": "新しく追加する"
      },
      "apply_to_urls": {
        "title": "URLに適用する",
        "description": "ルールを適用する特定のURLを選択する",
        "all_urls": "全てのURL",
        "selected_urls": "選択されたURL",
        "label": "適用するURL",
        "placeholder": "適用するURL",
        "original_url": "元のURL",
        "translated_url": "翻訳されたURL",
        "wildcard": "ワイルドカード",
        "regex": "正規表現",
        "add": "新しく追加する",
        "expression": "式の種類"
      },
      "apply_urls": {
        "title_exclude": "URLで除外する",
        "title_replace": "URLで置き換える",
        "title_description": "またこのルールをURLの翻訳にも適用する"
      },
      "apply_languages": {
        "title": "言語に適用する",
        "description": "ルールを適用する特定の言語を選択する",
        "all_languages": "全ての言語",
        "selected_languages": "選択された言語",
        "placeholder": "言語を選択中...",
        "feedback": "言語を選択する必要がある"
      },
      "name": {
        "title": "タイトル",
        "description": "便宜上、ルールにタイトルを付けてください",
        "placeholder": "ルール名"
      },
      "type": {
        "title": "タイプ",
        "description": "追加したいルールのタイプを選択する",
        "text_ignore": "テキストを無視する",
        "text_replace": "テキストを置換する",
        "content_exclusion": "コンテンツを除外する",
        "url_exclusion": "URL翻訳の除外",
        "ignore_inline": "インラインを無視",
        "full_description": {
          "text_ignore": "一部のテキストが翻訳されないようにルールを追加する。 あなたが翻訳したくない製品名、ブランド名、またはその他の技術的要素でも構いません。",
          "text_replace": "テキスト置換で一部のテキストを必要な翻訳に置き換えることができる、翻訳が内容を無視する時に必要になる。",
          "content_exclusion": "コンテンツの除外は、ページ内の一部の内容からの翻訳を回避する時に役立つ。\nページを翻訳から完全に除外したい場合（このページの多言語URLや翻訳されたコンテンツはまったくない）、URL翻訳の除外」を使用してください。",
          "url_exclusion": "ページ翻訳の除外は、翻訳したくないページを設定する時に役立ちます。",
          "ignore_inline": "一部のコンテンツをインライン コンテンツとして翻訳することは避け、代わりに各タグを個別に翻訳します。"
        }
      },
      "text_replace": {
        "title": "テキストを置き換える",
        "description": "一部のテキストを特定の翻訳に置き換える。 ページ全体のテキストを言語に置き換える",
        "text_to_replace": "テキストを置き換える",
        "ignore_case": "ケースを無視する",
        "text_type": "翻訳での置き換え",
        "text_type_original": "もともと",
        "text_type_translation": "翻訳",
        "keep_case": "ケースを維持するようにしてください",
        "add": "新しく追加する"
      },
      "content_exclusion": {
        "title": "コンテンツの除外",
        "description": "翻訳したない1つ以上のCSSセレクターを選択する",
        "label": "CSS セレクター",
        "placeholder": "適用するセレクター",
        "add": "新しく追加する"
      },
      "multilingual_url": {
        "title": "多言語のURLを使用する",
        "description": "はいに設定すると、URLは翻訳されないが、ページは翻訳されたコンテンツで多言語のままになる",
        "live_example_title": "実例",
        "live_example_description": "ソースURL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "生成されたURL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "生成されたURL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "静的コンテンツまたは動的コンテンツ、またはその両方にルールを適用します",
        "title": "コンテンツに適用します",
        "all": "すべてのコンテンツ",
        "static": "静的コンテンツ",
        "dynamic": "動的コンテンツ"
      },
      "force_apply_urls": {
        "title_description": "既存の翻訳を含むURLのすべての翻訳にこのルールを適用します！",
        "title_replace": "URLに力を置きます",
        "title_exclude": "URLで力を除外します",
        "warning": "警告",
        "warning_part1": "これを「はい」に設定すると、WebサイトのURL翻訳が破損する場合があります。",
        "warning_part2": "これは、一時的または永続的に404sページを生成できます。結果を理解している場合にのみ続行してください。",
        "warning_replacement_original": "追加の警告：URLに影響を与える可能性のある元のコンテンツを置き換えようとしている場合、リングは元のURLを適切に見つけることができないため、翻訳が失敗する可能性があります"
      }
    },
    "main": {
      "parent": "ルール",
      "edit": "ルールを編集する",
      "add": "新しいルール"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\"はコンテンツとURLで無視されます",
      "preview_single": "\"{{text_ignore}}\" はコンテンツで無視される",
      "preview_more_with_url": "\"{{text_ignore}}\" と {{count}} その他はコンテンツで無視される",
      "preview_more": "\"{{text_ignore}}\" と {{count}} その他はコンテンツで無視される",
      "other_parameters": "このルールには他のパラメータが設定されています。詳細情報を取得するには、編集ボタンをクリックしてください"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" は コンテンツとURLで\"{{replacement}}\"より置き換える",
      "preview_single": "\"{{original}}\" は コンテンツで \"{{replacement}}\"より置き換える",
      "preview_more_with_url": "\"{{original}}\" は コンテンツとURLまた{{nb}}以上で \"{{replacement}}\" より置き換える",
      "preview_more": "\"{{original}}\"は コンテンツと{{nb}}以上で \"{{replacement}}\" より置き換える",
      "other_parameters": "他のパラメータがこのルールに設定されている、詳細情報は、編集ボタンをクリックしてください"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSSセレクターが翻訳から除外された",
      "other_parameters": "他のパラメータがこのルールに設定されている、詳細情報は、編集ボタンをクリックしてください"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URLが翻訳から除外されたが,多言語プレフィックスは保持されている ",
      "some": "{{nb}} URLは翻訳から完全に除外されている",
      "all_multilingual": "全てのURLが翻訳から除外されたが,多言語プレフィックスは保持されている",
      "all": "全てのURLが翻訳から除外されている",
      "other_parameters": "他のパラメータがこのルールに設定されている、詳細情報は、編集ボタンをクリックしてください"
    },
    "ignore_inline": {
      "elements": "すべてのインライン コンテンツは、ページ上でブロックされたコンテンツとして翻訳されます",
      "all_elements": "一部のインライン コンテンツは、ページ上でブロックされたコンテンツとして翻訳されます",
      "other_parameters": "このルールには他のパラメータが設定されています。編集ボタンをクリックして詳細情報を取得してください。"
    },
    "title": "ルールの管理",
    "description": "あなたのウェブサイト全体で翻訳コンテンツの除外と置換を管理してください",
    "add": "新しくルールを追加する",
    "table": {
      "title": "タイトル",
      "type": "タイプ",
      "preview": "ルールのプレビュー",
      "action": "行動",
      "delete_confirm": "ルールの削除を確認してください",
      "types": {
        "text_ignore": "テキスト無視",
        "text_replace": "テキストの置換",
        "content_exclusion": "コンテンツの除外",
        "url_exclusion": "URL の除外",
        "ignore_inline": "インラインを無視",
        "unknown": "不明なルール"
      },
      "no_data": "ここにはまだルールがありません"
    },
    "apply_on_content": {
      "static": "このルールは静的コンテンツにのみ適用されます",
      "dynamic": "このルールは動的コンテンツにのみ適用されます"
    }
  },
  "search_translations": {
    "title": "翻訳を検索",
    "description": "検索フォームで使用されているすべてのウェブサイトの翻訳を一覧表示します（翻訳された言語からドメインの基本言語まで）",
    "filter_languages": "言語でフィルタかけている...",
    "filter_original": "元の言語で本文のフィルタをかける",
    "filter_translation": "翻訳された本文でフィルタをかける",
    "table": {
      "original": "もと",
      "language": "言語",
      "translation": "翻訳"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "購読に失敗しました!",
      "title": "購読に失敗しました!",
      "subtitle": "サブスクリプションを処理しようとしたときにエラーが発生しました。",
      "home": "家に帰りなさい",
      "generic": "Linguise 側で不明なエラーが発生しました。管理者に連絡してください。"
    },
    "success": {
      "home": "ドメイン翻訳の管理",
      "message": "当社は、可能な限り最高の翻訳体験を提供することに尽力しています。当社の専門家チームが、ご質問や必要なサポートに対応いたします。始めるには、下のボタンをクリックしてください。",
      "subtitle": "Linguise 翻訳サービスをお選びいただきありがとうございます",
      "title": "サブスクリプションが有効になりました!",
      "tab_title": "購読していただきありがとうございます!"
    }
  },
  "subscriptions": {
    "edit": {
      "title": "サブスクリプションを管理する"
    },
    "list": {
      "title": "サブスクリプション　リスト",
      "description": "あなたのドメインサブスクリプションのリスト"
    },
    "table": {
      "domain": "ドメイン",
      "plan": "プラン",
      "status": "ステータス",
      "card": "カード",
      "usage": "使用",
      "actions": "行動",
      "payment_method": "支払方法"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}}単語",
      "paidOffered": "{{words_used}} / {{words_allowed}}単語\n{{free_words}}が提供する単語を含む"
    },
    "success": {
      "tab_title": "サブスクリプションが有効になりました!",
      "title": "サブスクリプションが有効になりました!",
      "subtitle": "Linguise 翻訳サービスをお選びいただきありがとうございます",
      "message": "「私たちは、可能な限り最高の翻訳体験を提供することに尽力しています。当社の専門家チームが、ご質問や必要なサポートに対応いたします。始めるには、下のボタンをクリックしてください。",
      "home": "ドメイン翻訳の管理"
    },
    "popup": {
      "dueToday": "今日の合計期限",
      "nextPeriod": "{{date}}から開始"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "アカウントを選択してください"
    }
  },
  "translation": {
    "main": {
      "parent": "翻訳",
      "edit": "翻訳を編集する"
    },
    "form": {
      "original": {
        "title": " {{language}}でのもともと"
      },
      "is_inline": "この翻訳はインラインコンテンツから作成されている。",
      "inline_editor": {
        "count_warning": "インライン領域の数が原文と一致しません（{{current}} / {{expected}}）。",
        "restore_original": "元のテキストを復元",
        "insert_placeholder": "プレースホルダーを挿入",
        "drag": "ドラッグしてインライン領域を並べ替え",
        "area": "インラインエリア {{index}}",
        "restore": "不足しているインライン領域を復元"
      },
      "translation": {
        "title": "{{language}}での翻訳",
        "description": "あなたが上書きしたい翻訳"
      }
    },
    "copy": {
      "title": "手動翻訳にコピー",
      "label": "手動にコピー"
    },
    "level": {
      "base": {
        "title": "ベース翻訳",
        "subtitle": "自動 · Linguise Cloud翻訳",
        "empty": "このテキストにはベース翻訳がありません。",
        "overridden": "選択内容は保存されていますが、AI翻訳設定で「手動翻訳と選択した翻訳を上書き」が「はい」のため、代わりに最新のAI強化翻訳が表示されます。選択内容を使用するには、この設定をオフにしてください。"
      },
      "not_generated": "未生成",
      "none": "まだありません",
      "ai": {
        "title": "AI強化翻訳",
        "subtitle": "自動 · Linguise AI",
        "empty_title": "このテキストはまだ生成されていません",
        "empty_description": "Linguise AIは、ページとウェブサイトの文脈を踏まえて、より自然な翻訳を提供します。ここに表示するには：",
        "empty_step_1": "AI翻訳 › 設定を開き、「AI翻訳を有効にする」を「ルールのみ」「ライブエディターのみ」または「ルールとライブエディター」に設定します。",
        "empty_step_2": "このページに一致するルールで適用するか、ライブエディターからページごとに有効にします。",
        "empty_step_3": "生成されると、AI強化翻訳がここに表示されます。AIクレジットが消費されます。",
        "open_settings": "AI翻訳の設定を開く",
        "open_editor": "ライブエディターを開く",
        "overrides_selection": "選択内容は保存されていますが、AI翻訳設定で「手動翻訳と選択した翻訳を上書き」が「はい」のため、代わりにこのAI強化翻訳が表示されます。選択内容を使用するには、この設定をオフにしてください。",
        "overrides_version": "選択したバージョンは保存されていますが、AI翻訳設定で「手動翻訳と選択した翻訳を上書き」が「はい」のため、代わりに最新のAI強化バージョンが表示されます。選択したバージョンを使用するには、この設定をオフにしてください。"
      },
      "manual": {
        "title": "手動翻訳",
        "subtitle": "あなたが作成 · 自動翻訳より優先されます",
        "empty": "空",
        "saved_but_overridden": "あなたの選択として保存されましたが、AI翻訳設定で「手動翻訳を上書き」が「はい」のため、自動的には表示されません。この設定をオフにするまで、AI強化翻訳が優先されます。",
        "ignored": "AI翻訳設定で「手動翻訳を上書き」が「はい」のため、自動的には表示されません。このテキストで使用するには選択してください。",
        "label": "あなたの翻訳",
        "placeholder": "ご自身の翻訳を入力...",
        "last_updated": "最終編集：{{date}}",
        "save_hint": "手動翻訳を保存すると有効になります。",
        "delete": "手動翻訳を削除",
        "delete_confirm": "手動翻訳の削除を確認してください"
      }
    },
    "history": {
      "title": "AI強化バージョン",
      "subtitle": "ライブエディターからの再生成はすべて保存されます",
      "unknown_model": "不明なモデル",
      "current": "現在",
      "restore": "このバージョンを復元",
      "restore_note": "復元すると、そのバージョンが現在のAI強化翻訳になります。削除されるものはありません。",
      "version_of": "バージョン {{current}} / {{total}}",
      "hide": "履歴を非表示（{{total}}）",
      "show": "履歴を表示（{{total}}）"
    },
    "choose": {
      "title": "{{language}}の翻訳 · 訪問者に表示するものを選択",
      "current": "現在ウェブサイトに表示中：",
      "priority": "デフォルトの優先順位：手動 › AI強化 › ベース。選択はこの翻訳にのみ保存されます。",
      "reset": "デフォルトの優先順位に戻す",
      "reset_title": "このテキストの選択を破棄し、デフォルトの優先順位を再び使用します",
      "resetting": "リセット中 ..."
    }
  },
  "translations": {
    "title": "翻訳の管理",
    "description": "すべてのウェブサイトの翻訳を一覧表示して編集する。視覚的な翻訳にはライブエディターを使用する",
    "filter_languages": "言語でフィルタかけている...",
    "filter_original": "元の言語で本文のフィルタをかける",
    "filter_translation": "翻訳された本文でフィルタをかける",
    "table": {
      "original": "もと",
      "language": "言語",
      "action": "行動",
      "base": "ベース",
      "ai": "AI強化",
      "manual": "手動"
    },
    "filter_exact": "正確な一致",
    "badge": {
      "active": "有効",
      "overrides_manual": "手動を上書き"
    },
    "cell": {
      "none": "なし",
      "not_generated": "未生成",
      "ignored": "無視 – AIルール優先"
    },
    "tabs": {
      "all": "すべて",
      "manual": "手動あり",
      "ai": "AI強化あり",
      "base": "ベースのみ"
    },
    "levels_hint": "各テキストには最大3つのレベルがあり、「有効」と表示されているものが訪問者に表示されます。"
  },
  "url": {
    "main": {
      "parent": "URL",
      "edit": "URL翻訳を編集する"
    },
    "form": {
      "original": {
        "title": " {{language}}のもと"
      },
      "translation": {
        "title": "{{language}}でのURL翻訳",
        "description": "上書きするURL",
        "placeholder": "URLの翻訳オーバーライド",
        "invalid_full": "間違った形式で変更しようとしています。URL 変換のスラッグ/パス名のみを変更してください。",
        "invalid": "無効な URL/パスが指定されました"
      }
    }
  },
  "urls": {
    "title": "URLを管理する",
    "description": "すべてのウェブサイトのURLを翻訳したコンテンツを一覧表示して編集する（高度な、404エラーに注意してください）",
    "filter_languages": "言語でフィルタかけている...",
    "filter_original": "元の言語で本文のフィルタをかける",
    "filter_translation": "翻訳された本文でフィルタをかける",
    "table": {
      "original": "もと",
      "language": "言語",
      "url": "翻訳されたURL",
      "action": "行動",
      "edited": "元の翻訳が編集された"
    }
  }
}
